module.exports = __webpack_public_path__ + "static/media/2.df42fd13.jpg";